import { connect } from 'react-redux';
import set from 'lodash/set';
import View from './CompareGoalsView';
import { goalId as selectedGoalId } from '../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import {
  goalsAdditionalSavingsWhatIfsOrDefaultSelector,
  whatIfsNoImpactsOrDefaultSelector,
} from './CompareGoalsSelector';
import { setCompareGoalsOpen, updateCompareGoalsData, updateWhatIfsData } from '../WhatIfsActions';
import {
  loading,
  nullableFpIdSelector,
  compareGoalsIsDataLoadedSelector,
  popupLoadingSelector,
  whatIfTypeSelector,
  whatIfKeySelector,
} from '../WhatIfsSelector';
import {
  fetchCompareGoals,
  fetchAdditionalSavingsPlanImpact,
  optimizeGoals,
} from './CompareGoalsActions';

const mapStateToProps = (state, ownProps) => ({
  fpId: nullableFpIdSelector(state, ownProps),
  goalId: selectedGoalId(state, ownProps),
  loading: loading(state, ownProps),
  compareGoalsIsDataLoaded: compareGoalsIsDataLoadedSelector(state, ownProps),
  availableCashflow: ownProps.availableCashflow,
  maxCashflow: ownProps.maxCashflow,
  popupLoading: popupLoadingSelector(state, ownProps),
  goalsAdditionalSavingsWhatIfs: goalsAdditionalSavingsWhatIfsOrDefaultSelector(state, ownProps),
  whatIfsNoImpactsOrDefault: whatIfsNoImpactsOrDefaultSelector(state, ownProps),
  whatIfType: whatIfTypeSelector(state, ownProps),
  whatIfKey: whatIfKeySelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  store: (path, clientId, goalId, whatIfKey, whatIfType, targetWhatIfKey) => value => {
    if (whatIfKey === targetWhatIfKey) {
      const prefixToDitch = /^GoalsAdditionalSavingsWhatIfs[[][0-9]+[\]][.]WhatIfPanelItem[.]/;
      dispatch(
        updateWhatIfsData(
          clientId,
          goalId,
          whatIfType,
          set({}, path.replace(prefixToDitch, ''), value),
        ),
      );
    } else {
      dispatch(updateCompareGoalsData(path, value, clientId));
    }
  },
  onDismiss: clientId => () => {
    dispatch(setCompareGoalsOpen(clientId, false));
  },
  fetchCompareGoals: (clientId, fpId) => {
    dispatch(fetchCompareGoals(clientId, fpId));
  },
  optimizeGoals: (
    clientId,
    fpId,
    goalId,
    whatIfKey,
    whatIfType,
    goalsAdditionalSavingsWhatIfs,
  ) => () => {
    dispatch(
      optimizeGoals(clientId, fpId, goalId, whatIfKey, whatIfType, goalsAdditionalSavingsWhatIfs),
    );
  },
  fetchAdditionalSavingsPlanImpact: (
    clientId,
    fpId,
    goalId,
    whatIfType,
    whatIfKey,
    whatIfsList,
  ) => {
    dispatch(
      fetchAdditionalSavingsPlanImpact(clientId, fpId, goalId, whatIfType, whatIfKey, whatIfsList),
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
